<div class="admin-users-container">
  <app-prime-ng-data-table
    class="remove-border"
    [data]="users()"
    [columns]="tableColumns()"
    [options]="tableOptions"
    [loading]="loading()"
    [totalRecords]="totalEntries()"
    [multiSelect]="true"
    [dataKey]="'id'"
    [tableId]="tableId()"
    [persistColumnWidths]="false"
    [selectedRows]="getSelectedRowsArray()"
    [textFilters]="textFilters"
    [filterOptions]="filterOptions"
    [moreActions]="moreActions"
    [itemLabel]="'users'"
    [floatingToolbarActions]="floatingToolbarActions()"
    [showToolbar]="false"
    [showTextFilters]="false"
    [useSplitButton]="false"
    [addButtonTextDisabled]="!hasUsersAddEditPermission()"
    [addButtonNavigationCommands]="addUserNavigationCommands()"
    [rowDetailHref]="userRowDetailHref"

    (event)="onTableEvent($event)"
    (lazyLoad)="handleManualLazyLoad($event)"
    (rowSelect)="onRowSelect($event)"
    (rowUnselect)="onRowUnselect($event)"
    (selectAll)="onSelectAll($event)"
    (rowClick)="onRowClick($event)"
    (rowExpand)="handleRowExpand($event)"
    (toolbarActionClick)="onFloatingToolbarActionClick($event)"
    #datatableComponent>
  </app-prime-ng-data-table>

  <!-- Archive Confirmation Modal -->
  <app-confirmation-modal
    [config]="archiveModalConfig"
    [isOpen]="isArchiveModalOpen"
    (confirm)="onArchiveConfirm($event)"
    (cancel)="onArchiveCancel($event)">
  </app-confirmation-modal>

  <!-- Delete Confirmation Modal -->
  <app-confirmation-modal
    [config]="deleteModalConfig"
    [isOpen]="isDeleteModalOpen"
    (confirm)="onDeleteConfirm($event)"
    (cancel)="onDeleteCancel($event)">
  </app-confirmation-modal>
</div>
